import { render, staticRenderFns } from "./comment-dispute-history-original.vue?vue&type=template&id=3ec621f3"
import script from "./comment-dispute-history-original.vue?vue&type=script&lang=js"
export * from "./comment-dispute-history-original.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports